import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import recordLogo from '../assets/history-record.jpg';
import Container from '@mui/material/Container';
import CustomButton from '../../../components/common/CustomButton';

export function HubSection() {
  const { palette, typography } = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      id="hub"
      component="section"
      sx={{
        bgcolor: palette.primary.main,
        py: 8,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 6,
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              color: palette.primary.contrastText,
              gap: 2,
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontSize: {
                  xs: typography.h3.fontSize,
                  md: typography.h2.fontSize,
                },
                fontWeight: {
                  xs: typography.h3.fontWeight,
                  md: typography.h1.fontWeight,
                },
              }}
            >
              The Library of Us
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: typography.body1.fontSize,
                  md: '18px',
                },
                py: { xs: 1, md: 2 },
                lineHeight: '1.5',
              }}
            >
              Africa is not just a continent; it is a collection of living
              stories. Explore the largest digital archive of African traditions
              from the recipes that fed your ancestors to the folklore that
              guided them.
            </Typography>
            <Typography
              sx={{
                fontSize: {
                  xs: typography.body1.fontSize,
                  md: '18px',
                },
                pb: { md: 3 },
                whiteSpace: 'pre-line',
              }}
            >
              <>
                <Box
                  component="span"
                  sx={{ fontWeight: 700, color: palette.secondary.main }}
                >
                  LegacyTies Cultural Hub
                </Box>
                {
                  ' collects these fragmented pieces of heritage into one searchable sanctuary. Whether you are looking for the meaning of your last name or the origin of a family tradition, you will find the records here kept safe, kept alive.'
                }
              </>
            </Typography>
            <div>
              <CustomButton
                label="Explore the Archives"
                color="secondary"
                variant="contained"
                sx={{
                  alignSelf: 'center',
                  width: 'auto',
                  color: palette.primary.main,
                  '&:hover': {
                    color: 'white',
                  },
                }}
                onClick={() => navigate('/hub')}
              />
            </div>
          </Box>
          <Box
            sx={{
              flexBasis: '100%',
              height: '100%',
              py: { xs: 2, md: 0 },
            }}
          >
            <img
              src={recordLogo}
              alt="history records"
              loading="lazy"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '20px',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
